import { render, staticRenderFns } from "./CCAMultiSelect.vue?vue&type=template&id=01151ba2"
import script from "./CCAMultiSelect.vue?vue&type=script&lang=js"
export * from "./CCAMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports